import classes from './scroll-area.module.css'

const ScrollArea = {
  classNames: {
    scrollbar: classes.scrollbar,
  },
}

export default ScrollArea
